import { useEffect } from 'react'
import { ShoesState } from 'src/types'
import { getCtx } from 'src/util/canvas'
import { drawAtomsShoesFrontSurface } from '../drawAtomsShoesFrontSurface'

export const useDrawShoesFront = (id: string, state: ShoesState) => {
  useEffect(() => {
    const { ctx } = getCtx(id)
    if (ctx === null) return
    if (state.baseModel.productNumber === '') return
    drawAtomsShoesFrontSurface(ctx, state)
  }, [id, state])
}
